module.exports = __webpack_public_path__ + "2cb92be9171d6ded033fac28a91b1037.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/text.svg
// module id = 610
// module chunks = 0